import { useEffect, useState } from "react";

import { ILog } from "../Lib/Log/types";
import { IDeviceCompass, IMapLocationTracker} from "../Features/LocationInfo/types";
import { constrainAngleDegrees } from "../Features/Common/Units/utils";
import { resolveCompassHeadingDegress } from "./locationLogic";


const useDeviceCompass = (locationTracker: IMapLocationTracker, log: ILog): IDeviceCompass => {

    const isSupported = 'DeviceOrientationEvent' in window;
    const [deviceHeadingDegrees, setDeviceHeadingDegrees] = useState<number | null>(null);


    const disposeEvents = () => {
        window.removeEventListener("deviceorientation", onDeviceOrientationChange, true);
        (window as any).removeEventListener("deviceorientationabsolute", onDeviceOrientationChange, true);
    };
    
    useEffect(() => {

        if (!isSupported)
            return;

        disposeEvents();

        const win = window;

        if ('ondeviceorientationabsolute' in window) {
            (win as any).addEventListener("deviceorientationabsolute", onDeviceOrientationChange, true);
        } else if ('ondeviceorientation' in window) {
            win.addEventListener("deviceorientation", onDeviceOrientationChange, true);
        }

        return () => {
            disposeEvents();
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const onDeviceOrientationChange = (event: DeviceOrientationEvent) => {

        const isAbsolute = event.absolute === true || 'webkitCompassHeading' in event;
        const hasValue = event.alpha !== null || ((event as any).webkitCompassHeading !== undefined && (event as any).webkitCompassHeading >= 0);

        if (!isAbsolute || !hasValue) {
            return;
        }

        //Alpha is anti-clockwise from 0 (N). webkitCompassHeading is clockwise from 0 (N).
        let headingDegrees = (event as any).webkitCompassHeading != null ? (event as any).webkitCompassHeading : 360 - event.alpha!;

        headingDegrees = constrainAngleDegrees(headingDegrees);

        setDeviceHeadingDegrees(headingDegrees); 
    }

    return {
        isSupported,
        headingDegrees: resolveCompassHeadingDegress(deviceHeadingDegrees, locationTracker.location)
    };
};

export default useDeviceCompass;